import BACK_API from "../api/simulateAPI";


const getParameters = async (parameters = '') => {
  try {
    const result = await BACK_API().get('simulation/parametros' + parameters)
    return result.data
  } catch (error) {
    console.log(error)
    throw error   
  }
}


export default getParameters